import ByThemeListView from "../../backyard/view/theme/List.vue";
import ByThemeDetailView from "../../backyard/view/theme/Detail.vue";

let lbThemeRouter = [];

let byThemeRouter = [
	{
		path: 'theme/list',
		name: "byThemeListView",
		component: ByThemeListView,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "byThemeListView",
					title: "定制页面列表"
				}
			]
		}
	},
	{
		path: 'theme/detail/:id',
		name: "byThemeDetailView",
		component: ByThemeDetailView,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "byThemeListView",
					title: "定制页面列表"
				},
				{
					name: "byThemeDetailView",
					title: "预览"
				}
			]
		}
	}
];


export {lbThemeRouter, byThemeRouter}





// WEBPACK FOOTER //
// ./src/common/router/ThemeRouter.js